// @flow
import * as React from 'react'

import { colors } from '@toggl/style'

export const IconPswVisible = ({
  color = colors.beige,
  height = 20,
  width = 20,
}: {
  color?: string,
  height?: number,
  width?: number,
}) => (
  <svg width={width} height={height} fill={color} viewBox="0 0 20 20">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="_Icons-/-View-Copy-3">
        <g id="_Icons-/-Link-/-Neutral">
          <polygon id="Shape" points="0 0 20 0 20 20 0 20"></polygon>
        </g>
        <path
          d="M10.0227494,4 C13.9544363,4 16.9468532,6 19,10 C17.1000377,14 14.1142326,16 10.0425847,16 C5.97093673,16 2.95674184,14 1,10 C3.08347938,6 6.09106252,4 10.0227494,4 Z M10.017694,5.8 C6.9597153,5.8 4.62048397,7.2 3,10 C4.52191032,12.8 6.86628412,14.2 10.0331214,14.2 C13.1999587,14.2 15.5222516,12.8 17,10 C15.403108,7.2 13.0756727,5.8 10.017694,5.8 Z M10,7 C11.6568542,7 13,8.34314575 13,10 C13,11.6568542 11.6568542,13 10,13 C8.34314575,13 7,11.6568542 7,10 C7,8.34314575 8.34314575,7 10,7 Z"
          id="Combined-Shape"
          fill="#7E6E85"
        ></path>
      </g>
    </g>
  </svg>
)
